export default function PrivacyPolicyPage({ }) {
    return (
        <main className="flex-grow-1">
            {/* <div id="heading-container" className="container pb-4">
                <h1 className="display-5 fw-medium mb-0">Privacy Policy</h1>
            </div> */}

            <div className="container py-2">
                <h1 className="h3">Privacy policy</h1>
                <p>Thank you for visiting Transfer.zip. This Privacy Policy outlines how we handle and protect your
                    personal information when you use our website. Please read this policy carefully to understand
                    our practices regarding your data and how we ensure your privacy.</p>

                <h2 className="h4">Information We Collect</h2>

                <p> <b>Personal Information:</b> Transfer.zip does not collect any personal information.</p>

                <p> <b>Third-Party Services:</b> Google AdSense, a third-party advertising service, may collect
                    information as described in their own privacy policy. This information may include non-personal
                    information such as browser type, operating system, and referral source. Transfer.zip serves ads
                    to minimize the costs of running the service. The domain name is not cheap!</p>

                <h2 className="h4">Contact Information</h2>

                <p>If you have any questions, concerns, or inquiries regarding this Privacy Policy or the practices
                    of
                    Transfer.zip, you can contact us via the github page. We will make every effort
                    to respond to your communication promptly.</p>

                <h2 className="h4">Changes to the Privacy Policy</h2>

                <p>We reserve the right to modify or update this Privacy Policy at any time. Any changes made will
                    be
                    effective immediately upon posting the revised Privacy Policy on Transfer.zip. We encourage you
                    to
                    review this Privacy Policy periodically to stay informed about how we are protecting your
                    information.</p>

                <h2 className="h4">Data Security</h2>

                <p>At Transfer.zip, we prioritize the security and privacy of our users. We have implemented
                    measures
                    to ensure the protection of your data, although we do not collect or store any user information
                    on
                    our servers. Our website operates in a client-side manner, which means that all data processing
                    and
                    storage occur locally on your device.</p>

                <p>As a result, we do not have access to or control over any data you generate or manipulate on our
                    website. This approach eliminates the need for us to implement specific security measures for
                    user
                    data, as no information is transmitted or stored on our servers. Any data you handle on
                    Transfer.zip
                    remains within the confines of your device and browser.</p>

                <p>While we take reasonable steps to ensure the security of our website and maintain a safe browsing
                    environment, it is important to remember that the security of your device and browser settings
                    are
                    ultimately your responsibility. We recommend keeping your operating system, browser, and
                    security
                    software up to date to minimize potential risks.</p>

                <h2 className="h4">Compliance with Laws</h2>

                <p>Transfer.zip complies with all applicable data protection laws and regulations. This Privacy
                    Policy
                    is intended to be in line with the General Data Protection Regulation (GDPR) and other relevant
                    privacy laws.</p>

                <h2 className="h4">Consent</h2>

                <p>By using Transfer.zip, you consent to the terms outlined in this Privacy Policy and agree to the
                    collection, use, and disclosure of your information as described herein.</p>

                <p>If you do not agree with this Privacy Policy, please refrain from using Transfer.zip.</p>

                <p>Please note that this privacy policy is for informational purposes only and should not be
                    considered
                    as legal advice. For detailed legal advice, please consult a qualified attorney.</p>
            </div>
        </main>
    )
}